// extracted by mini-css-extract-plugin
module.exports = {"info":"CouponField_info__3DDY9","promoCodeDiv":"CouponField_promoCodeDiv__2okE2","promoCode":"CouponField_promoCode__2RN-o","apply":"CouponField_apply__2u80g"};